import React from 'react';
import { RouteComponentProps } from 'react-router-dom';

import './Home.scss';
import { useIsAuthenticated } from '@azure/msal-react';
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IHomeProps {}

const Home = (props: RouteComponentProps<IHomeProps>) => {
  const isUserAuthenticated = useIsAuthenticated();

  if (isUserAuthenticated) {
    props.history.push('/login');
    return null;
  }

  return <div className="main">Redirecting you to sign-in page...</div>;
};

export default Home;
